import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';
import { type RouteComponentProps } from 'react-router-dom';

import { fg } from '@atlaskit/platform-feature-flags';

type TeamEmbedProps = { teamId: string };

const TeamEmbedSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_team-embed-page" */ './main'
		),
);

const LazyTeamEmbedNext = (props: TeamEmbedProps): React.ReactElement => (
	<Suspense fallback={null}>
		<TeamEmbedSuspense {...props} />
	</Suspense>
);

const LazyTeamEmbedLegacy: ComponentType<TeamEmbedProps> & Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_team-embed-page" */ './main'
		),
	loading: () => null,
});
LazyTeamEmbedLegacy.displayName = 'lazy(LazyTeamEmbed)';

const LazyTeamEmbed = (props: TeamEmbedProps): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? (
		<LazyTeamEmbedNext {...props} />
	) : (
		<LazyTeamEmbedLegacy {...props} />
	);

const TeamEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ teamId: string }>, 'match'>): React.JSX.Element => {
	return <LazyTeamEmbed teamId={match.params.teamId} />;
};

export default TeamEmbedRoute;
